import { render, staticRenderFns } from "./paymentMethod.vue?vue&type=template&id=f6e6451e&"
import script from "./paymentMethod.vue?vue&type=script&lang=js&"
export * from "./paymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports